import { render } from "./ModalTransporterGroupsDelete.vue?vue&type=template&id=1a7cf628"
import script from "./ModalTransporterGroupsDelete.vue?vue&type=script&lang=js"
export * from "./ModalTransporterGroupsDelete.vue?vue&type=script&lang=js"

import "./ModalTransporterGroupsDelete.vue?vue&type=style&index=0&id=1a7cf628&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__